import { SETTINGS_FACEBOOK_PERMISSIONS } from "@anydo/core";
import { loadFacebook } from "../loaders/loadFacebook";

export async function getFacebookToken(): Promise<string> {
  const FB = await loadFacebook();

  return new Promise((resolve, reject) => {
    const premissions = {
      scope: SETTINGS_FACEBOOK_PERMISSIONS,
    };

    FB.login(response => {
      var status = response.status;
      if (status === "connected") {
        resolve(response.authResponse.accessToken);
        return true;
      } else {
        reject(new Error("Couldn't login with Facebook"));
        return false;
      }
    }, premissions);
  });
}
